(function (window, document) {

	ImgsContainer = function (opts) {
		return (this instanceof ImgsContainer)
			? this.init(opts)
			: new ImgsContainer(opts);
	};

	ImgsContainer.prototype.init = function (opts) {
		var self = this;

		opts = opts || {};
		self.loadedCallback = opts.loadedCallback;
		self.updatedCallback = opts.updatedCallback;
		
		self.statClass = { loading: 'loading', loaded: 'loaded' };
		if (typeof opts.statClass !== "undefined") {
			self.statClass.loading = typeof opts.statClass.loading !== "undefined" ? opts.statClass.loading : self.statClass.loading;
			self.statClass.loaded = typeof opts.statClass.loaded !== "undefined" ? opts.statClass.loaded : self.statClass.loaded;
		}

		self.wrapper = [];
		for (var w = 0, len = opts.containerObj.length; w < len; w++) {
			var imgs = opts.containerObj[w].querySelectorAll('img, video');
			self.wrapper[w] = {
				obj : opts.containerObj[w],
				imgs : imgs,
				loader : [],
				loadedCount : 0
			};
			if (self.wrapper[w].imgs.length > 0) {
				self.load(w);
			} else {
				self.loaded(w);
			}
		}
	};

	ImgsContainer.prototype.load = function (w) {
		var self = this,
			theWrap = self.wrapper[w],
			tagName = '';

		theWrap.obj.classList.add(self.statClass.loading);

		for (var i=0, len=theWrap.imgs.length; i<len; i++) {
			theWrap.loader[i] = new Image();
			theWrap.loader[i].onload = function(){
				self.loadCount(w);
			};
			theWrap.loader[i].onerror = function(){
				self.loadCount(w);
			};
			tagName = theWrap.imgs[i].tagName.toUpperCase();
			if (tagName === 'IMG') {
				theWrap.loader[i].setAttribute('src', theWrap.imgs[i].getAttribute('src'));
			} else if (tagName === 'VIDEO') {
				theWrap.loader[i].setAttribute('src', theWrap.imgs[i].getAttribute('poster'));
			}
		}

	};

	ImgsContainer.prototype.loadCount = function (w) {
		var self = this,
			theWrap = self.wrapper[w];

		theWrap.loadedCount += 1;

		if (theWrap.loadedCount >= theWrap.imgs.length) {
			self.loaded(w);
		} else {
			self.updated();
		}
	}

	ImgsContainer.prototype.updated = function () {
		var self = this;
		if (typeof self.updatedCallback === "function") {
			self.updatedCallback(self);
		}
	};

	ImgsContainer.prototype.loaded = function (w) {
		var self = this;
		self.wrapper[w].obj.classList.remove(self.statClass.loading)
		self.wrapper[w].obj.classList.add(self.statClass.loaded);

		if (typeof self.loadedCallback === "function") {
			self.loadedCallback(self, self.wrapper[w].obj);
		}
	};




  
	BlockArranger = function (opts) {
		return (this instanceof BlockArranger) ? this.init(opts) : new BlockArranger(opts);
	};

	BlockArranger.prototype.init = function (opts) {
		var self = this;

		self.opts = opts || {};
		self.trackWindow = (self.opts.trackWindow || document.body);
		self.classPrefix = self.opts.classPrefix || 'blar';
		self.wrapClass = self.classPrefix + '-wrap';
		self.itemClass = self.classPrefix + '-item';
		self.showClass = self.classPrefix + '-show';
		self.spacerClass = self.classPrefix + '-space';
		self.observerConf = { attributes: true, childList: true, subtree: true, characterData: true };

		self.loadHTML();
	};


	BlockArranger.prototype.loadHTML = function () {
		var self = this,
			w = 0;

		self.wraps = [];
		var wraps = document.getElementsByClassName(self.wrapClass);
		for (w = 0; w < wraps.length; w++) {
			self.wraps[w] = {};
			self.wraps[w].obj = wraps[w];
			self.wraps[w].observer = new MutationObserver(function (mutations) {
				this.disconnect();
				for (var i = 0, length = mutations.length; i < length; i++) {
					var mutation = mutations[i];
					if (mutation.type === 'childList') {
						self.loadHTMLWrapper(this.baWrapIndex);
						break;
					} else if (!mutation.type === 'attributes'
						|| (mutation.type === 'attributes' && mutation.target.className.indexOf(self.classPrefix) == -1)) {
						self.setColumn(this.baWrapIndex);
						break;
					}
				}
				this.observe(this.baWrapObj, this.observerConf);
			});
			self.wraps[w].observer.baWrapIndex = w;
			self.wraps[w].observer.baWrapObj = self.wraps[w].obj;
			self.wraps[w].observer.observerConf = self.observerConf;
			self.wraps[w].observer.observe(self.wraps[w].obj, self.observerConf);

			self.loadHTMLWrapper(w);
		}

		window.addEventListener('resize', function resizeWrappers(){
			self.resizeWrappers();
		}, {
			passive: true
		});
	}

	BlockArranger.prototype.loadHTMLWrapper = function (w) {
		var self = this,
			theWrap = null,
			theItem = null,
			items = [];

		theWrap = self.wraps[w];
		theWrap.items = [];
		theWrap.switchPoint = BlockArranger.isset(theWrap.obj.getAttribute('data-switchPoint'))
			? JSON.parse(theWrap.obj.getAttribute('data-switchPoint')) : (self.opts.switchPoint || [[0,3]]);
		theWrap.alignment = BlockArranger.isset(theWrap.obj.getAttribute('data-alignment'))
			? theWrap.obj.getAttribute('data-alignment') : (self.opts.alignment || 'left');
		theWrap.maxColumn = 0;

		theWrap.padding = BlockArranger.isset(theWrap.obj.getAttribute('data-padding'))
			? parseInt(theWrap.obj.getAttribute('data-padding'), 10) : (self.opts.padding || 0);
		theWrap.minPaddingPx = BlockArranger.isset(theWrap.obj.getAttribute('data-minPaddingPx'))
			? parseInt(theWrap.obj.getAttribute('data-minPaddingPx'), 10) : (self.opts.minPaddingPx || 0);

		theWrap.fadeIn = BlockArranger.isset(theWrap.obj.getAttribute('data-fadeIn'))
			? (theWrap.obj.getAttribute('data-fadeIn') === "true" ? true : false) : (self.opts.fadeIn || false);
		theWrap.fadeInSpeed = BlockArranger.isset(theWrap.obj.getAttribute('data-fadeInSpeed'))
			? parseInt(theWrap.obj.getAttribute('data-fadeInSpeed'), 10) : (self.opts.fadeInSpeed || 100);

		theWrap.enableStretch = BlockArranger.isset(theWrap.obj.getAttribute('data-enableStretch'))
			? (theWrap.obj.getAttribute('data-enableStretch') === "true" ? true : false) : (self.opts.enableStretch || false);
		theWrap.maxStretchHeightPx = BlockArranger.isset(theWrap.obj.getAttribute('data-maxStretchHeightPx'))
			? parseInt(theWrap.obj.getAttribute('data-maxStretchHeightPx'), 10) : (self.opts.maxStretchHeightPx || -1);

		theWrap.spacerNo = 0;
		theWrap.spacerObj = [];
		theWrap.enableSpacer = BlockArranger.isset(theWrap.obj.getAttribute('data-enableSpacer'))
			? (theWrap.obj.getAttribute('data-enableSpacer') === "true" ? true : false) : (self.opts.enableSpacer || false);
		theWrap.minSpacerHeightPx = BlockArranger.isset(theWrap.obj.getAttribute('data-minSpacerHeightPx'))
			? parseInt(theWrap.obj.getAttribute('data-minSpacerHeightPx'), 10) : (self.opts.minSpacerHeightPx || 3);

		theWrap.maxVisiblePoint = BlockArranger.isset(theWrap.obj.getAttribute('data-maxVisiblePoint'))
			? JSON.parse(theWrap.obj.getAttribute('data-maxVisiblePoint')) : (self.opts.maxVisiblePoint || [0,-1]);
		theWrap.maxCount = 0;


		theWrap.obj.style.display = 'block';
		theWrap.obj.style.position = 'relative';

		items = theWrap.obj.getElementsByClassName(self.itemClass);
		theWrap.items = [];
		for (var i=0, len=items.length; i<len; i++) {
			theItem = theWrap.items[i] = {};
			theItem.obj = items[i];
			theItem.obj.style.position = 'absolute';
			theItem.obj.style.margin = '0';
			theItem.obj.style.padding = '0';
			theItem.offsetBottom = 0;
			theItem.switchPoint = (BlockArranger.isset(theItem.obj.getAttribute('data-switchPoint'))
				? JSON.parse(theItem.obj.getAttribute('data-switchPoint')) : '')
				|| [[0, BlockArranger.isset(theItem.obj.getAttribute('data-colspan')) ? parseInt(theItem.obj.getAttribute('data-colspan'), 10) : 1]];
			theItem.alignment = BlockArranger.isset(theItem.obj.getAttribute('data-alignment'))
				? theItem.obj.getAttribute('data-alignment') : (theWrap.alignment || 'left');
		}

		self.resizeWrapper(w);

		ImgsContainer( {
			containerObj : [theWrap.obj],
			updatedCallback : function () {
				self.setColumn(w);
			},
			loadedCallback : function () {
				self.setColumn(w);
				if (theWrap.fadeIn) {
					for (i=0, len=theWrap.items.length; i<len; i++) {
						setTimeout(function(no){
							theWrap.items[no].obj.classList.add(self.showClass);
						}, theWrap.fadeInSpeed * i, i);
					}
				} else {
					for (i=0, len=theWrap.items.length; i<len; i++) {
						theWrap.items[i].obj.classList.add(self.showClass);
					}
				}
			}
		} );

	};

	BlockArranger.prototype.resizeWrappers = function () {
		var self = this,
			w = 0;

		for (w = 0; w < self.wraps.length; w++) {
			self.resizeWrapper(w);
		}
	};
	BlockArranger.prototype.resizeWrapper = function (w) {
		var self = this,
			i = 0, s = 0,
			theWrap = self.wraps[w],
			theItem = null,
			windowWidth = self.trackWindow.clientWidth;

		theWrap.paddingPx = (theWrap.obj.clientWidth / 100) * theWrap.padding;
		if (theWrap.paddingPx < theWrap.minPaddingPx) {
			theWrap.paddingPx = theWrap.minPaddingPx;
			theWrap.padding = (theWrap.minPaddingPx / theWrap.obj.clientWidth) * 100;
		}

		for (s = 0; s < theWrap.switchPoint.length; s += 1) {
			if (windowWidth < theWrap.switchPoint[s][0]) {
				break;
			}
			theWrap.maxColumn = theWrap.switchPoint[s][1];
		}
		for (s = 0; s < theWrap.maxVisiblePoint.length; s += 1) {
			if (windowWidth < theWrap.maxVisiblePoint[s][0]) {
				break;
			}
			theWrap.maxCount = theWrap.maxVisiblePoint[s][1];
		}

		for (i = 0; i < theWrap.items.length; i += 1) {
			theItem = theWrap.items[i];
			for (s = 0; s < theItem.switchPoint.length; s += 1) {
				if (windowWidth < theItem.switchPoint[s][0]) {
					break;
				}
				theItem.colspan = theItem.switchPoint[s][1];
				if (theItem.colspan == 0) {
					theItem.obj.style.display = 'none';
				} else {
					theItem.obj.style.display = 'block';
				}
			}
			theItem.colspan = theItem.colspan < theWrap.maxColumn ? theItem.colspan : theWrap.maxColumn;
		}

		self.setColumn(w);
	};

	BlockArranger.prototype.setColumn = function (w) {
		var self = this,
			i = 0, r = 0, len = 0,
			theWrap = self.wraps[w],
			theItem = null,
			oneColWidthPer = 0,
			lastColH = [],
			lastColObj = [],
			insertPos = 0,
			afterH = 0,
			putColH = [],
			wrapHeight = 0,
			itemLength = 0;

		theWrap.observer.disconnect();
		theWrap.spacerNo = 0;
		self.initSpacer(theWrap);

		oneColWidthPer = (100 - (theWrap.maxColumn - 1) * theWrap.padding) / theWrap.maxColumn;
		lastColH = new Array(theWrap.maxColumn);
		lastColObj = new Array(theWrap.maxColumn);

		for (i = 0; i < lastColH.length; i += 1) {
			lastColH[i] = theWrap.paddingPx;
			lastColObj[i] = null;
		}

		itemLength = theWrap.maxCount >= 0 ? Math.min(theWrap.maxCount, theWrap.items.length) : theWrap.items.length;
		for (i = 0; i < itemLength; i += 1) {
			theItem = theWrap.items[i];

			if (!BlockArranger.visible(theItem.obj)) { continue; }

			putColH = [];
			for (r = 0, len = theWrap.maxColumn - theItem.colspan; r <= len; r += 1) {
				putColH[r] = Math.max.apply(null, lastColH.slice(r, r + theItem.colspan));
			}
			insertPos = theItem.alignment == 'left'
				? putColH.indexOf(Math.min.apply(null, putColH))
				: putColH.lastIndexOf(Math.min.apply(null, putColH));

			theItem.obj.style.top = putColH[insertPos] + 'px';
			theItem.obj.style.left = ((oneColWidthPer + theWrap.padding) * insertPos) + '%';
			theItem.obj.style.width = ((oneColWidthPer + theWrap.padding) * theItem.colspan - theWrap.padding) + '%';
			theItem.obj.style.height = 'auto';
			theItem.originalH = theItem.obj.clientHeight;

			afterH = putColH[insertPos] + theItem.obj.clientHeight + theWrap.paddingPx;
			for (r = insertPos, len = insertPos + theItem.colspan; r < len; r += 1) {
				if (theWrap.enableSpacer && putColH[insertPos] - lastColH[r] - theWrap.paddingPx > theWrap.minSpacerHeightPx) {
					self.getSpacer(theWrap, lastColH[r], (oneColWidthPer + theWrap.padding) * r, oneColWidthPer, putColH[insertPos] - lastColH[r] - theWrap.paddingPx);
				}
				lastColObj[r] = theItem;
				lastColH[r] = theItem.offsetBottom = afterH;
			}

			if (theWrap.enableStretch) {
				var diff = 0, rr = 0;
				for (r = 0; r < lastColObj.length; r += 1) {
					if (lastColObj[r] !== null && (r + lastColObj[r].colspan - 1 < insertPos || insertPos + theItem.colspan <= r)) {
						diff = lastColObj[r].offsetBottom - theItem.offsetBottom;
						if (0 < diff && theItem.obj.clientHeight + diff - theItem.originalH <= theWrap.maxStretchHeightPx ) {
							theItem.obj.style.height = (theItem.obj.clientHeight + diff) + 'px';
							theItem.offsetBottom = lastColObj[r].offsetBottom;
							for (rr = insertPos; rr < insertPos + theItem.colspan; rr += 1) {
								lastColH[rr] = theItem.offsetBottom;
							}
							break;
						} else if (diff < 0 && lastColObj[r].obj.clientHeight - diff - lastColObj[r].originalH <= theWrap.maxStretchHeightPx) {
							lastColObj[r].obj.style.height = (lastColObj[r].obj.clientHeight - diff) + 'px';
							lastColObj[r].offsetBottom = theItem.offsetBottom;
							for (rr = r; rr < r + lastColObj[r].colspan; rr += 1) {
								lastColH[rr] = theItem.offsetBottom;
							}
						}
					}
				}
			}
			
		}
		for (i = itemLength; i < theWrap.items.length; i += 1) {
			theItem = theWrap.items[i];
			theItem.obj.style.display = 'none';
		}

		wrapHeight = Math.max.apply(null, lastColH);
		if (theWrap.enableSpacer) {
			for (r = 0, len = lastColH.length; r < len; r += 1) {
				if (wrapHeight - lastColH[r] - theWrap.paddingPx > theWrap.minSpacerHeightPx) {
					self.getSpacer(theWrap, lastColH[r], (oneColWidthPer + theWrap.padding) * r, oneColWidthPer, wrapHeight - lastColH[r] - theWrap.paddingPx);
				}
			}
		}

		theWrap.obj.style.height = wrapHeight + 'px';
		theWrap.observer.observe(theWrap.obj, self.observerConf);
	};

	BlockArranger.prototype.initSpacer = function (theWrap) {
		theWrap.spacerObj.forEach(function(value) {
			value.style.top = '0';
			value.style.left = '0';
			value.style.width = '0';
			value.style.height = '0';
		});
	};
	BlockArranger.prototype.getSpacer = function (theWrap, top, left, width, height) {
		var self = this;

		if (typeof theWrap.spacerObj[theWrap.spacerNo] === "undefined") {
			theWrap.spacerObj[theWrap.spacerNo] = document.createElement('div');
			theWrap.spacerObj[theWrap.spacerNo].classList.add(self.spacerClass);
			theWrap.obj.appendChild(theWrap.spacerObj[theWrap.spacerNo]);
		}
		theWrap.spacerObj[theWrap.spacerNo].style.position = 'absolute';
		theWrap.spacerObj[theWrap.spacerNo].style.top = top + 'px';
		theWrap.spacerObj[theWrap.spacerNo].style.left = left + '%';
		theWrap.spacerObj[theWrap.spacerNo].style.width = width + '%';
		theWrap.spacerObj[theWrap.spacerNo].style.height = height + 'px';
		theWrap.spacerNo++;
	};





	BlockArranger.isset = function (data) {
		if (data === "" || data === null || typeof data === "undefined") {
			return false;
		}
		return true;
	};

	BlockArranger.visible = function (element) {
		var style = document.defaultView.getComputedStyle(element);

		if (style.display === 'none'
			|| style.visibility !== 'visible'
		) {
			return false
		}
		return true;
	};


}(window, document));

window.addEventListener('DOMContentLoaded', () => {

    if( $('.arbox-wrap').length > 0 ) {
        BlockArranger( { classPrefix:'arbox', padding:2, switchPoint:[ [0, 1], [550, 2], [1000, 3] ] } );
    }

    $('.mailto').each(function(index,element){
        var user = $(this).attr('data-user');
        var domain = '';
        switch( $(this).attr('data-site') ){
          	case 'ouestvillage':
				domain = 'ouestvillage.com';
            break;
            case 'ileavacom':
                domain = 'ileava.com';
            break;
            case 'ileavajp':
                domain = 'ileava.jp';
            break;
         }
        $(this).append( $('<a>').attr('href','mailto:' + user + '@' + domain ).html( user + '@' + domain ) );
    });

/* //for stone purchase type
    if( $('.ile-cart-designs-opt').length > 0 ) {
      window.addEventListener('pageshow', () => {
        var $cart_designs_opt = $('.ile-cart-designs-opt');
        if ($cart_designs_opt.attr('data-reflesh') === 'true') {
          var $cart_designs_opt_sample = $('.ile-cart-designs-opt+ul li input'),
              $cart_designs_opt_selected = $('.ile-cart-designs-opt+ul li input:checked'),
              selected_value = $cart_designs_opt_selected.length > 0 ? $cart_designs_opt_selected.val() : '',
              product_form_id = $cart_designs_opt_sample.attr('form'),
              purchase_type_label = $cart_designs_opt_sample.attr('name');
          $.getJSON('/cart.js', function(cart){
            var optsHtml = "";
            for (var n = 0; n < cart.items.length; n++) {
              if (cart.items[n].product_type == "Design") {
                var cpt = $('html').attr('lang') == 'en' ? 'for ['+ cart.items[n].title +'] in&nbsp;your&nbsp;cart' : 'カート内 ['+ cart.items[n].title +'] 用',
                    cpid = $cart_designs_opt.attr('data-id') + '-c' + n;
                optsHtml += '<li><input id="'+ cpid +'" type="radio" form="'+ product_form_id +'" name="'+ purchase_type_label +'" value="'+ cart.items[n].title +'" '+ (selected_value == '' || selected_value == cart.items[n].title ? 'checked' : '') +'><label for="'+ cpid +'">'+ cpt +'</label></li>';
              }
            }
            $cart_designs_opt.html(optsHtml);
          });
        }
      });
    }
*/
});

